import { ContentTypes } from "../brandVariables.types";

export const logitechContent: ContentTypes = {
  generalHeadline: "Logitech speed champions",
  generalHeadlineAlt: "Set the fastest time!",
  subHeadline: "Lorem ipsum...",
  overviewHeadline: "Dreamhack winter 2024 winners overview!",
  endscreenHeadline: "THANK YOU TO OUR WINNERS",
};
